export default "__VITE_ASSET__DTL19Cer__"